module.exports = __webpack_public_path__ + "static/media/SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv.ebd2dccb.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/thumbs/SG-SNI4_1zh6BrWWyDtiriDnL8Ig1YkOVE56bYmPv
// module id = 856
// module chunks = 0